import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Select,
  Form,
  message,
  Input,
  Button,
  notification,
  Modal,
  Tooltip,
} from "antd";
import { CopyOutlined, PlusOutlined } from "@ant-design/icons";
import config from "../../util/ApiforContext";
import Screen from "../../util/Extensions/Screens";
import SweetAlert from "react-bootstrap-sweetalert";
import RequestHandler from "../../util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TransactionBankInfoAddForm = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pdfAlertVisible, setPdfAlertVisible] = useState(false);
  const [bankDropdown, setbankDropdown] = useState({
    data: [],
    loading: true,
  });
  const [bankBranchDropdown, setbankBranchDropdown] = useState({
    data: [],
    loading: true,
  });
  const [currencyDropdown, setCurrencyDropdown] = useState({
    data: [],
    loading: true,
  });
  const [activeBankId, setActiveBankId] = useState(0);
  const [activeVersion, setActiveVersion] = useState(0);
  const [callbackUrl, setCallbackUrl] = useState();

  const [bankRequirements, setBankRequirements] = useState({});

  useEffect(() => {
    getBankDropdownData();
    getCurrencyDropdownData();
  }, []);

  useEffect(() => {
    if (activeVersion == 62001) {
      getGarantiCallbackUrl();
    } else {
      setCallbackUrl();
    }
  }, [activeVersion]);

  useEffect(() => {
    if (bankDropdown.data.length > 0 && activeBankId != 0) {
      form.setFieldsValue({ bankId: parseInt(activeBankId) });

      getBankInfoRequirements(activeBankId, 0);
    }
  }, [bankDropdown, activeBankId]);

  useEffect(() => {
    getBankDropdownData();
    getCurrencyDropdownData();

    if (props.code && props.state) {
      const splitState = props.state.split("/");

      if (splitState.length > 1) {
        form.setFieldsValue({ customerNumber: splitState[0] });
        setActiveBankId(splitState[1]);

        setLoading(true);

        const formData = new FormData();

        formData.append("customerNumber", splitState[0]);
        formData.append("firmKey", props.code);
        formData.append("bankId", splitState[1]);
        formData.append("isUseNewVersionBankApi", true);

        formPost(formData);
      }
    }
  }, [props.code]);

  useEffect(() => {
    if (props.demoInformation) {
      welcome();
    }
    if (
      bankRequirements.isRequiredAccountInfo &&
      bankRequirements.isBankBranchIdRequired
    ) {
      getBankBranchDropdownData();
    }
  }, [bankRequirements]);

  const onFinish = (values, e) => {
    if (bankRequirements.redirectToPermissionPage) {
      window.location.href = `${bankRequirements.permissionUrl}&state=${values.customerNumber}/${values.bankId}`;

      e.preventDefault();
    }

    const formData = new FormData();

    for (const key in values) {
      if (key !== "cerFile" && key !== "keyFile") {
        formData.append(key, values[key]);
      }
    }

    if (values.cerFile) {
      formData.append("cerFile", values.cerFile.fileList[0].originFileObj);
    }

    if (values.keyFile) {
      formData.append("keyFile", values.keyFile.fileList[0].originFileObj);
    }

    formPost(formData);
  };

  const formPost = (formData) => {
    RequestHandler.post(`/TransactionBankInfo/AddWithBankCheck`, formData).then(
      (res) => {
        setLoading(false);
        if (res.success) {
          form.resetFields();
          getBankDropdownData();
          setActiveBankId(0);

          if (props.onSuccess) props.onSuccess();
        }
      },
    );
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onCancelPdfAlert = () => {
    setPdfAlertVisible(false);
  };
  const onConfirmPdfAlert = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);
    setTimeout(hide, 2500);

    const pdfEndPoint = `/Pdf/DownloadPdfByBankId?id=${activeBankId}&screenOption=${
      Screen.screen
    }&t=${RequestHandler.getToken()}`;

    RequestHandler.get(pdfEndPoint).then((res) => {
      window.open(config.apiUrl + pdfEndPoint);
      setPdfAlertVisible(false);
      notifyPdfDownloadSuccess();
    });
  };

  const notifyPdfDownloadSuccess = () => {
    notification.success({
      message: "BAŞARILI",
      description: "Pdf indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const getBankInfoRequirements = (bankId, version) => {
    RequestHandler.get(
      `/Bank/GetBankColumnsByBankId/${bankId}/${version}`,
    ).then((response) => {
      setBankRequirements({
        isRequiredAccountInfo: response.isRequiredAccountInfo,
        ...response.bankInfoRequiredColumns,
        ...response.bankInfoAccountRequiredColumns,
        versions: response.versions,
      });
    });
  };

  const getGarantiCallbackUrl = () => {
    RequestHandler.get(`/TransactionBankInfo/GarantiApiCallbackUrl`).then(
      (response) => {
        setCallbackUrl(response.data);
      },
    );
  };

  const onActiveBankChange = (bankId) => {
    setActiveBankId(bankId);
    setActiveVersion(0);
    form.setFieldsValue({ version: 0 });

    getBankInfoRequirements(bankId, 0);

    if (bankId != 205) {
      setPdfAlertVisible(true);
    }
  };

  const onActiveVersionChange = (version) => {
    setActiveVersion(version);
    getBankInfoRequirements(activeBankId, version);
  };

  const getBankDropdownData = () => {
    setbankDropdown({
      ...bankDropdown,
      loading: true,
    });

    RequestHandler.get(`/Bank/GetBankDropdown`).then((response) => {
      setbankDropdown({
        data: response.filter((x) => x.id !== 999),
        loading: false,
      });
    });
  };
  function welcome() {
    Modal.confirm({
      title: "Merhaba",
      content:
        "Banka hesabı tanımlaması yaptığınız takdirde demo kayıtlarınız silinecektir.",
      okText: "Anladım",
      keyboard: false,
      cancelButtonProps: { hidden: true },
    });
  }
  const getBankBranchDropdownData = () => {
    setbankBranchDropdown({
      ...bankBranchDropdown,
      loading: true,
    });

    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${activeBankId}`).then(
      (response) => {
        setbankBranchDropdown({
          data: response,
          loading: false,
        });
      },
    );
  };

  const getCurrencyDropdownData = () => {
    setCurrencyDropdown({
      ...currencyDropdown,
      loading: true,
    });

    RequestHandler.get(`/Currency`).then((response) => {
      setCurrencyDropdown({
        data: response.value,
        loading: false,
      });
    });
  };

  return (
    <>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="addForm"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={24}>
            <Form.Item label="Banka" name="bankId" rules={[{ required: true }]}>
              <Select
                showSearch
                placeholder="Banka Seçiniz"
                optionFilterProp="children"
                onChange={onActiveBankChange}
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                loading={bankDropdown.loading}
              >
                {bankDropdown.data.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {bankRequirements.versions?.length > 1 && (
              <Form.Item
                label="Versiyon"
                name="version"
                initialValue={activeVersion}
              >
                <Select
                  placeholder="Seçiniz"
                  value={activeVersion}
                  onChange={onActiveVersionChange}
                >
                  {bankRequirements.versions.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            {bankRequirements.isUserNameRequired && (
              <Form.Item
                label={bankRequirements.userNameLabel ?? "Kullanıcı Adı"}
                name="userName"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isUserCodeRequired && (
              <Form.Item
                label={bankRequirements.userCodeLabel ?? "Kullanıcı Kodu"}
                name="userCode"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isPasswordRequired && (
              <Form.Item
                label={bankRequirements.passwordLabel ?? "Şifre"}
                name="password"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isCustomerNumberRequired && (
              <Form.Item
                label={
                  bankRequirements.customerNumberLabel ?? "Müşteri Numarası"
                }
                name="customerNumber"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isCorporateCodeRequired && (
              <Form.Item
                label={bankRequirements.corporateCodeLabel ?? "Kurum Kodu"}
                name="corporateCode"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isServiceUrlRequired && (
              <Form.Item
                label={bankRequirements.serviceUrlLabel ?? "Url"}
                name="serviceUrl"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isFirmNameRequired && (
              <Form.Item
                label={bankRequirements.firmNameLabel ?? "Firma Adı"}
                name="firmName"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isFirmKeyRequired && (
              <Form.Item
                label={bankRequirements.firmKeyLabel ?? "Firma Anahtarı"}
                name="firmKey"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {callbackUrl && (
              <Form.Item
                label="Tanımlanacak Callback Url"
                name="callbackUrl"
                initialValue={callbackUrl}
              >
                <Input.Group compact>
                  <Input
                    readOnly
                    value={callbackUrl}
                    style={{ width: "calc(100% - 36px)" }}
                  />
                  <Tooltip title="Kopyala">
                    <Button
                      icon={<CopyOutlined />}
                      onClick={() => navigator.clipboard.writeText(callbackUrl)}
                    />
                  </Tooltip>
                </Input.Group>
              </Form.Item>
            )}

            {bankRequirements.isRequiredAccountInfo ? (
              <>
                {bankRequirements.isBankBranchIdRequired && (
                  <Form.Item
                    label="Şube Kodu"
                    name="bankBranchId"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen şube kodu alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Şube seçiniz"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={bankBranchDropdown.loading}
                    >
                      {bankBranchDropdown.data.map((item) => (
                        <Select.Option key={item.id}>{item.name}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {bankRequirements.isAccountNumberRequired && (
                  <Form.Item
                    label="Hesap Numarası"
                    name="accountNumber"
                    rules={[
                      {
                        required: true,
                        message:
                          "Lütfen hesap numarası alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input maxLength="17" />
                  </Form.Item>
                )}

                {bankRequirements.isIbanRequired && (
                  <Form.Item
                    label="Iban/Hesap No"
                    name="iban"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Iban/Hesap No alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input type="text" maxLength="26" />
                  </Form.Item>
                )}

                {bankRequirements.isAccountSuffixRequired && (
                  <Form.Item
                    label="Hesap Ek Numarası"
                    name="accountSuffix"
                    rules={[
                      {
                        required: true,
                        message:
                          "Lütfen Hesap Ek Numarası alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input maxLength="4" />
                  </Form.Item>
                )}

                {bankRequirements.isCurrencyIdRequired && (
                  <Form.Item
                    label="Döviz Kodu"
                    name="currencyId"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen döviz kodu alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Para birimini seçiniz"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencyDropdown.loading}
                    >
                      {currencyDropdown.data.map((item) => (
                        <Select.Option key={item.id}>
                          {item.code + " (" + item.symbol + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </>
            ) : null}

            <Col style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
      <SweetAlert
        show={pdfAlertVisible}
        showCancel
        confirmBtnText={"Hayır"}
        cancelBtnText={"Evet"}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        title={"Uyarı"}
        onConfirm={onConfirmPdfAlert}
        onCancel={onCancelPdfAlert}
      >
        Erişim Bilgilerinizi Bankanızdan Aldınız mı?
      </SweetAlert>
    </>
  );
};
export default TransactionBankInfoAddForm;
